import type { MilestoneDefinition, Trophy } from '@/milestones/types'

export interface CelebrationItem {
  id: string
  trophy: Trophy
  def: MilestoneDefinition
  newTier?: number
  enqueueAt: number
}

type Listener = (items: CelebrationItem[]) => void

class CelebrationQueue {
  private items: CelebrationItem[] = []
  private listeners: Set<Listener> = new Set()

  push(item: Omit<CelebrationItem, 'enqueueAt'>): void {
    const sixtySecAgo = Date.now() - 60_000
    if (this.items.some((i) => i.id === item.id && i.enqueueAt > sixtySecAgo)) return
    this.items.push({ ...item, enqueueAt: Date.now() })
    this.emit()
  }

  pop(): CelebrationItem | null {
    const first = this.items.shift() ?? null
    if (first) this.emit()
    return first
  }

  current(): CelebrationItem | null {
    return this.items[0] ?? null
  }

  subscribe(l: Listener): () => void {
    this.listeners.add(l)
    l([...this.items])
    return () => this.listeners.delete(l)
  }

  clear(): void {
    this.items = []
    this.emit()
  }

  private emit() {
    const snapshot = [...this.items]
    this.listeners.forEach((l) => l(snapshot))
  }
}

export const celebrationQueue = new CelebrationQueue()
